// extracted by mini-css-extract-plugin
module.exports = {"item":"_fa859d21","imageWrapper":"_5557ae00","image":"_c1d85553","title":"_76fdef14"};